import(/* webpackMode: "eager" */ "/tmp/8dee1deb9475ae8/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dee1deb9475ae8/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dee1deb9475ae8/src/app/metrics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dee1deb9475ae8/src/components/ClientInit/ClientInit.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee1deb9475ae8/src/providers/index.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dee1deb9475ae8/src/styles/global.scss");
